var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import { UrlHelper } from '../../helper/UrlWrapper';
import { EBillType } from '../../enum/EBillType';
import { toDetail } from '../../helper/util';
import GlobalVue from '../../globalVue';
import IncomeOrderService from '../../api/IncomeOrderService';
import ArtMsglist from '../../components/alert/ArtMsglist.vue';
import Add from './Add.vue';
import Header from './components/Header.vue';
import ImportData from './components/ImportData.vue';
import CommonService from "../../api/CommonService";
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.searchParams = null;
        _this.selectRows = [];
        _this.tableHeight = 300;
        _this.organList = [];
        _this.formData = {};
        _this.isMoreSearch = false;
        _this.shipStatusList = [
            { name: '全部', value: '-1' },
            { name: '待发货', value: 0 },
            { name: '部分发货', value: 1 },
        ];
        return _this;
    }
    List.prototype.created = function () {
        this.service = IncomeOrderService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    List.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    List.prototype.isShowEditBtn = function (row) {
        var isToReviewed = row.order_status === 0;
        var isOrderType = row.order_type === 37 || row.order_type === 38;
        if (isToReviewed && isOrderType)
            return true;
        return false;
    };
    List.prototype.edit = function (row) {
        this.addTab({
            component: Add,
            title: row.order_type === 37 ? '修改库存报溢单' : '修改库存报损单',
            showExist: true,
            name: 'incomeorder_edit' + row.order_id,
            cprops: {
                order_id: row.order_id,
            },
        });
        if (row.order_type === 37) {
            window._czc.push(['_trackEvent', '库存报溢单', '库存报溢单编辑']);
        }
        else {
            window._czc.push(['_trackEvent', '库存报损单', '库存报损单编辑']);
        }
    };
    List.prototype.add = function () {
        this.addTab({
            component: Add,
            title: '添加损溢单',
            showExist: true,
            name: 'incomeorder_add',
            cprops: {},
        });
        window._czc.push(['_trackEvent', '损益单', '损益单添加']);
    };
    List.prototype.importAudit = function () {
        this.$refs.ImportData.showImportModal();
    };
    List.prototype.audit = function () {
        var _this = this;
        if (!this.checkSelectIds())
            return;
        this.$confirm('审核后将不可修改，是否继续？').then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var order_ids = _this.getSelectIds();
            _this.service
                .audit({
                order_ids: order_ids,
            })
                .then(function (res) {
                loadingInstance.close();
                if (res.data.code === 56) {
                    var instance = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    return;
                }
                else if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getList();
                    return;
                }
                _this.$message.success('审核成功');
                window._czc.push(['_trackEvent', '损溢单', '损溢单审核']);
                _this.$refs.pagination.clear();
                _this.getList();
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    List.prototype.discard = function () {
        var _this = this;
        if (!this.checkSelectIds())
            return;
        this.$confirm('废弃后将不可修改，是否继续？').then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var order_ids = _this.getSelectIds();
            _this.service
                .cancel({
                order_ids: order_ids,
            })
                .then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success(res.data.msg);
                    window._czc.push(['_trackEvent', '损溢单', '损溢单废弃']);
                    _this.$refs.pagination.clear();
                }
                _this.getList();
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    List.prototype.getSelectIds = function () {
        var order_ids = this.selectRows.map(function (item) { return item.order_id; });
        return order_ids.join(',');
    };
    List.prototype.checkSelectIds = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择单据！');
            return false;
        }
        else {
            return true;
        }
    };
    List.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.importAudit();
                break;
            case 2:
                this.exportData();
                break;
            case 3:
                this.discard();
                break;
        }
    };
    List.prototype.exportData = function () {
        var _this = this;
        var orderIds = this.selectRows.map(function (item) {
            return item.order_id;
        }) || [];
        var params = {
            order_ids: orderIds.join(",")
        };
        this.service.incomeExport(params).then(function (res) {
            if (res.data.success) {
                if (res.data.code == 66) {
                    _this.$message.success(res.data.msg || '导出数据量超过1万条时，将通过异步方式生成下载链接，请注意查看系统消息');
                }
                else {
                    _this.exportDataOne(orderIds);
                }
            }
        }).catch(function (err) {
            console.log(err);
        });
    };
    List.prototype.exportDataOne = function (orderIds) {
        var _this = this;
        var url = 'supplierclientapi/incomeorder/export_detail?order_ids=' + orderIds.join(',');
        url = UrlHelper.addParam(url, "is_export", '1');
        url = UrlHelper.addParam(url, 'token', this.user.token);
        for (var key in this.filter) {
            this.filter[key] = (this.filter[key] === undefined || this.filter[key] === null) ? '' : this.filter[key];
            url = UrlHelper.addParam(url, key, this.filter[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        window._czc.push(['_trackEvent', '损溢单导出', '损溢单导出']);
    };
    List.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        filter.order_status = filter.order_status.join(',');
        this.filter = filter;
        this.filter.depot_ids = (filter.depot_ids || []).join(',');
        this.getList();
    };
    List.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getList(Object.assign({}, this.filter, __assign({}, pager, { sort_field: this.order ? this.order[0] : null, sort_type: this.order ? this.order[1] : null })))
            .then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    List.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    List.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    List.prototype.lookDetail = function (row) {
        toDetail(EBillType.IncomeOrder, row.order_id, this);
    };
    List.prototype.resetData = function () { };
    List.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    List.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            if (prop == 'order_status_name') {
                prop = 'order_status';
            }
            this.order = [prop, order === 'ascending' ? 'ASC' : 'DESC'];
        }
        this.getList();
    };
    List = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
            })),
            components: {
                'list-header': Header,
                'import-data': ImportData,
            },
        })
    ], List);
    return List;
}(Vue));
export default List;
